import { useState } from 'react';
import { trpc } from '../../api/trpc';
import type { AuditFilterState } from './AuditFilters';

interface AuditExportProps {
  filters: AuditFilterState;
}

export function AuditExport({ filters }: AuditExportProps) {
  const [open, setOpen] = useState(false);
  const [exporting, setExporting] = useState(false);

  const exportMutation = trpc.audit.export.useQuery(
    {
      format: 'json', // placeholder — actual format set at call time
      ...(filters.eventType ? { eventType: filters.eventType } : {}),
      ...(filters.eventCategory ? { eventCategory: filters.eventCategory as 'conversation' | 'system_configuration' | 'task_agent' | 'security_event' | 'data_access' } : {}),
      ...(filters.actorId ? { actorId: filters.actorId } : {}),
      ...(filters.startDate ? { startDate: filters.startDate } : {}),
      ...(filters.endDate ? { endDate: filters.endDate } : {}),
    },
    { enabled: false },
  );

  const handleExport = async (format: 'csv' | 'json') => {
    setExporting(true);
    setOpen(false);
    try {
      // Use a direct fetch since we need a different format per call
      const params = new URLSearchParams();
      params.set('format', format);
      if (filters.eventType) params.set('eventType', filters.eventType);
      if (filters.eventCategory) params.set('eventCategory', filters.eventCategory);
      if (filters.actorId) params.set('actorId', filters.actorId);
      if (filters.startDate) params.set('startDate', filters.startDate);
      if (filters.endDate) params.set('endDate', filters.endDate);

      // Re-use the tRPC query by refetching
      const result = await exportMutation.refetch();
      if (result.data) {
        const blob = new Blob([result.data.data], { type: result.data.contentType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = result.data.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="audit-export-dropdown">
      <button
        className="audit-export-btn"
        onClick={() => setOpen(!open)}
        disabled={exporting}
      >
        {exporting ? 'Exporting...' : 'Export \u25BE'}
      </button>
      {open && (
        <div className="audit-export-menu">
          <button onClick={() => void handleExport('csv')}>Export as CSV</button>
          <button onClick={() => void handleExport('json')}>Export as JSON</button>
          <button disabled>Export as PDF (coming soon)</button>
        </div>
      )}
    </div>
  );
}
